import { ReactElement, ReactNode } from 'react';

import { Stack } from '@mui/material';

import { Button } from '../buttons';
import { HexIcon, HexIconElementProps } from '../hex-icons';
import * as Icons from '../icons';
import { Placeholder } from '../placeholders';

export type DestroyFormGuardProps = {
  title?: ReactNode;
  subtitle?: ReactNode;
  onLeave?: () => void;
  onContinue?: () => void;
  icon?: ReactElement<HexIconElementProps>;
};

export const DestroyFormGuard = ({
  title = 'Are you sure you want to leave without saving?',
  subtitle = 'By leaving without saving, all the changes will be lost.',
  onLeave,
  onContinue,
  icon = <HexIcon variant="notification" icon={<Icons.Question />} />,
}: DestroyFormGuardProps) => {
  return (
    <Placeholder
      icon={icon}
      title={title}
      body={subtitle}
      actions={
        <Stack direction="row" gap={16}>
          <Button
            variant="secondary"
            onClick={() => onLeave?.()}
            testId="form-guard-leave-btn"
          >
            Leave
          </Button>
          <Button
            onClick={() => onContinue?.()}
            testId="form-guard-continue-btn"
          >
            Continue editing
          </Button>
        </Stack>
      }
    />
  );
};
